import React, { memo } from "react";
import Spinner from "../spinner/spinner";

type LoadingProps = {
    show?: boolean;
    message?: string;
    radius?: number;
    color?: string;
};

const Loading: React.FC<LoadingProps> = (props: LoadingProps) => {
    return (
        <>
            {props.show && (
                <>
                    <Spinner
                        data-testid="Loading"
                        radius={props.radius}
                        color={props.color}
                        visible
                        stroke={3}
                    />
                    <br />
                    <h5 className="text-center">{props.message}</h5>
                </>
            )}
        </>
    );
};

Loading.defaultProps = {
    show: false,
    message: "",
    radius: 5,
    color: "#0099cc",
};

export default memo(Loading);
